import { Component } from '@angular/core';
import { MsgTimelineContent } from '../../msg-interface/msg-timeline-content';
import { _MSGTYPES, MSG_CONTENT_TYPE } from '../../shared/constant/msgType';
import { TimelineSourceData } from '../../msg-interface/data-model';
import { URLS } from '../../shared/constant/interface';
import { isJsonString } from '../../shared/utils/common';

@Component({
  selector: 'icc-tiktok-timeline-content',
  templateUrl: './tiktok-timeline-content.component.html',
  styles: [],
})
export class TiktokTimelineContentComponent implements MsgTimelineContent {
  constructor() {}
  SCENE = 'icc-msg-timeline-content';
  type = _MSGTYPES.MT.TIKTOK.type;

  isMo: boolean;
  content: any;
  contentType: number;
  name: string;

  // 地址前缀
  baseUrl = URLS.attachment.url + '?';
  contentTypes = MSG_CONTENT_TYPE;

  /* 赋值 */
  setData(data: TimelineSourceData) {
    this.isMo = data.isMo;
    if (isJsonString(data.content)) {
      const jsonContent = JSON.parse(data.content);
      const parsedContent = jsonContent instanceof Array && jsonContent.length ? jsonContent[0] : jsonContent;
      this.contentType = parsedContent.contentType;
      switch (parsedContent.contentType) {
        case MSG_CONTENT_TYPE.IMAGE:
          // 图片
          const imgList = [];
          const tempArr = parsedContent.mediaList;
          if (tempArr instanceof Array) {
            tempArr.forEach(imgItem => {
              imgList.push({
                name: imgItem.name,
                url: this.baseUrl + imgItem.url,
              });
            });
          }
          this.content = imgList;
          break;
        case MSG_CONTENT_TYPE.VIDEO:
          // 抖音单视频
          this.content = this.baseUrl + parsedContent.mediaList[0].url;
          this.name = parsedContent.mediaList[0].name;
          break;
        default:
          break;
      }
    }
  }
}

